import classNames from 'classnames';
import React, { useContext } from 'react';
import ReactModal from 'react-modal';
import { HasClassName } from '../component-utils';
import { useTeams } from '../TeamsProvider';
import './Modal.scss';

export default function Modal({ className, onRequestClose, children, ...props }: React.PropsWithChildren<ReactModal.Props>) {
  const { theme } = useTeams()
  return <ReactModal className={classNames(`theme-${theme}`, className)} onRequestClose={onRequestClose} {...props}>
    <ModalContext.Provider value={{ onRequestClose }}>
      {children}
    </ModalContext.Provider>
  </ReactModal>
}

type ModalContextData = {
  onRequestClose?(event: (React.MouseEvent | React.KeyboardEvent)): void
}

const ModalContext = React.createContext<ModalContextData>({})

type ModalHeaderProps = React.PropsWithChildren<HasClassName>

function ModalHeader({ className, children }: ModalHeaderProps) {
  const { onRequestClose } = useContext(ModalContext)

  return <div className={classNames('ModalHeader', className)}>
    {children}
    {onRequestClose && <button className='close' onClick={onRequestClose}>
      <svg viewBox='0 0 24 24'>
        <path d='M14.8,12l3.6-3.6c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0L12,9.2L8.4,5.6c-0.8-0.8-2-0.8-2.8,0
            c-0.8,0.8-0.8,2,0,2.8L9.2,12l-3.6,3.6c-0.8,0.8-0.8,2,0,2.8C6,18.8,6.5,19,7,19s1-0.2,1.4-0.6l3.6-3.6l3.6,3.6
            C16,18.8,16.5,19,17,19s1-0.2,1.4-0.6c0.8-0.8,0.8-2,0-2.8L14.8,12z'/>
      </svg>
    </button>}
  </div>
}

Modal.Header = ModalHeader
